import { Box, Button, Flex, Heading, Img, Link, Text } from '@chakra-ui/react'
import React from 'react'

const ProjectCard = ({img,name, description,live, github,arr}) => {
  return (
    <Box  bg="#2253c8" borderRadius={"5px"} p="10px"   w="400px" h="500px">
      <Box >
        <Img borderRadius={"5px"} src={img} />
      </Box>
      <Text fontSize={"25px"} color="white">{name}</Text>
      <Text fontWeight={600} fontSize={"17px"}  >{description}</Text>
      <Flex 
      justifyContent={"center"}
      gap="5px"
      m={"15px 0px"}
      >
      {
        arr?.map((elem,index)=>(
          <Box p="5px" borderRadius={"3px"} bg="white" h="50px" w="50px" key={index}>
          <Img alt={elem}  src={elem} h="100%" w="100%" />
          </Box>
        ))
      }
      </Flex>

      <Link target={"_blank"} href={live} ><Button _hover={{color:"white", bg:"#2253c8"}} border="1px solid white" bg="white" color="#2253c8" m="10px">Live</Button></Link>
      <Link target={"_blank"} href={github} ><Button _hover={{color:"white", bg:"#2253c8"}} border="1px solid white" bg="white" color="#2253c8" m="10px">Github</Button></Link>

    </Box>
  )
}

export default ProjectCard